'use client';

import type { ComponentProps } from 'react';
import React from 'react';
import { Flex, Link } from '@skin-seoul/design-system';
import type { ProductCardProps } from '../ProductCard.types';
import { ProductCardProvider } from '../ProductCardContext';
import ProductCardInfoName from '../components/ProductCardInfoName';
import ProductCardInfoRating from '../components/ProductCardInfoRating';
import { ProductCardInfoPrice } from '../components/ProductCardInfoPrice';
import { HorizontalProductCardContent } from './HorizontalProductCardContent';
import { HorizontalProductCardImage } from './HorizontalProductCardImage';
import ProductCardAddToCart from '../components/ProductCardAddToCart';

type HorizontalProductCardProps = ProductCardProps & ComponentProps<typeof Link>;

export const HorizontalProductCard = ({
  children,
  theme,
  onClick,
  ranking,
  orientation = 'horizontal',
  ...props
}: HorizontalProductCardProps) => {
  return (
    <ProductCardProvider
      value={{
        ...props,
        orientation,
        theme,
        ranking,
      }}
    >
      <Link
        unstyled
        borderRadius="8px"
        display="flex"
        backgroundColor={theme === 'dark' ? 'generic.100' : 'generic.0'}
        flexDirection="row"
        width="100%"
        alignItems="center"
        cursor="pointer"
        height={ranking ? '164px' : '136px'}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(e);
        }}
        {...props}
      >
        <Flex width="100%" height="100%" position="relative">
          <>{children}</>
        </Flex>
      </Link>
    </ProductCardProvider>
  );
};

HorizontalProductCard.Content = HorizontalProductCardContent;
HorizontalProductCard.Image = HorizontalProductCardImage;
HorizontalProductCard.InfoName = ProductCardInfoName;
HorizontalProductCard.InfoRating = ProductCardInfoRating;
HorizontalProductCard.InfoPrice = ProductCardInfoPrice;
HorizontalProductCard.AddToCart = ProductCardAddToCart;
